__webpack_require__.p = "/RoboFriends/";